import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';
import { setupCountryCascade, setupCascade } from 'locations';

export default class extends Controller {
  static values = { details: String, id: String, type: String }
  static get targets() {
    return [];
  } 

  connect(){
    this.toggleAddress();
  }
  toggleAddress(event) {
    console.log("toggleAddress");
    let placeId = $(this.element).find(this.idValue).val();
    let placeType = $(this.element).find(this.typeValue).val();
    let details = $(this.element).find(this.detailsValue);

    if (placeType == 'SpecialDestination' && placeId == '1') {
      details.show();
    } else {
      details.hide();
    } 
  }
}
